import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useQuery } from "react-query";

// primereact
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import { Tooltip } from "primereact/tooltip";

// components
import Toggle from "../../../../../components/button/Toggle";
import Modal from "../../../../../components/modal/Modal";

// services
import { getUser } from "../../../../../services/GeneralRegistration/getUser";

const ModalEditCel = ({ visible, onHide, userId, onConfirm, usuario = {} }) => {
  const formAccordion = useForm({
    defaultValues: {
      allowEdit: false,
      cadastroEnabled: false,
      edicaoEnabled: false,
      cadastroCampos: {},
      edicaoCampos: {},
      telefones: [],
    },
    mode: "onChange",
  });
  const { control, watch, setValue, reset, formState } = formAccordion;
  const values = watch();

  // Busca contatos do usuário selecionado
  const { data: userData, isLoading: isLoadingContacts } = useQuery(
    ["getUserContacts", userId],
    () => getUser(userId),
    {
      enabled: !!userId && visible,
      refetchOnWindowFocus: false,
    }
  );

  const [nomePessoa, setNomePessoa] = useState("");
  const [isAtivo, setIsAtivo] = useState(true);

  useEffect(() => {
    if (usuario && visible) {
      setNomePessoa(usuario.nome || usuario.pessoa?.nome || "");
      setIsAtivo(usuario.ativo !== false);
    }
  }, [usuario, visible]);

  useEffect(() => {
    if (userData && visible) {
      const telefones = Array.isArray(userData.contacts)
        ? userData.contacts
            .filter(
              (t) =>
                t &&
                typeof t.number === "string" &&
                t.number.trim() !== "" &&
                t.type_number === 1
            )
            .map((t) => t.number)
        : [];
      let telefonesSelecionados = [];
      if (usuario && usuario.pessoa && Array.isArray(usuario.pessoa.contacts)) {
        telefonesSelecionados = usuario.pessoa.contacts
          .map((c) => c.number)
          .filter((t) => telefones.includes(t));
      } else if (usuario.telefone) {
        if (Array.isArray(usuario.telefone)) {
          telefonesSelecionados = usuario.telefone.filter((t) =>
            telefones.includes(t)
          );
        } else if (typeof usuario.telefone === "string") {
          telefonesSelecionados = [usuario.telefone].filter((t) =>
            telefones.includes(t)
          );
        }
      } else if (usuario.contacts && Array.isArray(usuario.contacts)) {
        telefonesSelecionados = usuario.contacts
          .map((c) => c.number)
          .filter((t) => telefones.includes(t));
      }
      if (telefonesSelecionados.length === 0 && telefones.length === 1) {
        telefonesSelecionados = [telefones[0]];
      }
      reset({
        allowEdit: usuario.allowEdit || false,
        cadastroEnabled: usuario.cadastroEnabled || false,
        edicaoEnabled: usuario.edicaoEnabled || false,
        cadastroCampos: usuario.cadastroCampos || {},
        edicaoCampos: usuario.edicaoCampos || {},
        telefones: telefonesSelecionados,
      });
    }
  }, [userData, usuario, visible, reset]);

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(values.telefones);
    }
    onHide();
  };

  const telefonesOptions = Array.isArray(userData?.contacts)
    ? userData.contacts
        .filter(
          (t) =>
            t &&
            typeof t.number === "string" &&
            t.number.trim() !== "" &&
            t.type_number === 1
        )
        .map((t) => ({ label: t.number, value: t.number }))
    : [];

  return (
    <Modal
      dynamicTitle={`Editar ${nomePessoa}`}
      visible={visible}
      onHide={onHide}
      style={{ width: 400, zIndex: 10000 }}
      modal={true}
    >
      <div className="row d-flex">
        <Tooltip target=".custom-target-icon" />
        <div className="col-md-7">
          <Controller
            name="telefones"
            control={control}
            render={({ field }) => (
              <MultiSelect
                value={field.value}
                onChange={(e) => field.onChange(e.value)}
                options={telefonesOptions}
                optionLabel="label"
                placeholder={
                  isLoadingContacts ? "Carregando..." : "Selecione os telefones"
                }
                style={{ width: "100%" }}
                disabled={
                  isLoadingContacts || telefonesOptions.length === 0 || !isAtivo
                }
              />
            )}
          />
        </div>
        <div className="col-md-5">
          <Controller
            name="allowEdit"
            control={control}
            render={({ field }) => (
              <Toggle
                control={control}
                name="allowEdit"
                onLabel="Permitir Edição"
                offLabel="Não Permitir Edição"
                tooltip="Permitir que as configurações desse usuario sobreponham as configurações globais"
                tooltipOptions={{ position: "top" }}
                getFormErrorMessage={(name) =>
                  formAccordion.formState.errors[name]?.message
                }
                disabled={!isAtivo}
                checked={field.value}
                onChange={(e) => field.onChange(e)}
              />
            )}
          />
        </div>
        {!isAtivo && (
          <div
            style={{
              color: "#dc3545",
              fontSize: 14,
              marginTop: 8,
              textAlign: "center",
            }}
          >
            Este usuário está desativado e não pode ser editado.
          </div>
        )}
        {values.allowEdit && (
          <>
            <div className="row g-4 flex-wrap">
              <div
                className="mt-5 border-bottom w-100 px-0"
                style={{ marginLeft: 0, marginRight: 0 }}
              >
                <div className="d-flex align-items-center  justify-content-between mb-2">
                  <span>Salvar documentos no cadastro geral</span>
                  <Controller
                    name="salvarDoc"
                    control={control}
                    render={({ field }) => (
                      <InputSwitch
                        checked={field.value}
                        onChange={(e) => field.onChange(e.value)}
                        disabled={!isAtivo}
                      />
                    )}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span>Confirmar cadastro</span>
                  <Controller
                    name="confirmarCadastro"
                    control={control}
                    render={({ field }) => (
                      <InputSwitch
                        checked={field.value}
                        onChange={(e) => field.onChange(e.value)}
                        disabled={!isAtivo}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 border-end border-2 border-light-subtle pe-md-4 mb-4 mb-md-0">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <Controller
                    name="cadastroEnabled"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        checked={field.value}
                        onChange={(e) => {
                          field.onChange(e.checked);
                          if (!e.checked) {
                            [
                              "rg",
                              "filiacao",
                              "orgaoExpedidor",
                              "uf",
                              "nacionalidade",
                            ].forEach((key) => {
                              formAccordion.setValue(
                                `cadastroCampos.${key}`,
                                false
                              );
                            });
                          }
                        }}
                        disabled={!isAtivo}
                      />
                    )}
                  />
                  <span className="fw-semibold">Cadastrar</span>
                  <i
                    className="pi pi-question-circle text-secondary custom-target-icon"
                    data-pr-tooltip="Permitir que a IA cadastre automaticamente esses campos."
                    data-pr-position="right"
                    data-pr-at="right+5 top"
                    data-pr-my="left center-2"
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div className="mb-3">
                  <span className="fw-semibold">
                    Campos obrigatórios para cadastro
                  </span>
                  {(() => {
                    const camposObrigatoriosCadastro = [
                      "Nome *",
                      "CPF *",
                      "Data de Nascimento *",
                    ];
                    return (
                      <ul className="mb-0 ps-4" style={{ fontSize: 15 }}>
                        {camposObrigatoriosCadastro.map((campo) => (
                          <li key={campo}>{campo}</li>
                        ))}
                      </ul>
                    );
                  })()}
                  <small className="text-muted">
                    Esses campos serão exigidos pela IA ao cadastrar
                  </small>
                </div>
                <div className="mb-2">
                  <span className="fw-semibold">Opções extras permitidas:</span>
                  {[
                    {
                      label: "RG",
                      key: "rg",
                    },
                    {
                      label: "Filiação",
                      key: "filiacao",
                    },
                    {
                      label: "Órgão Expedidor",
                      key: "orgaoExpedidor",
                    },
                    {
                      label: "UF",
                      key: "uf",
                    },
                    {
                      label: "Nacionalidade",
                      key: "nacionalidade",
                    },
                  ].map((campo) => (
                    <div
                      key={campo.key}
                      className="d-flex align-items-center mb-2 gap-3"
                    >
                      <span className="me-2 flex-grow-1">{campo.label}</span>
                      <Controller
                        name={`cadastroCampos.${campo.key}`}
                        control={control}
                        render={({ field }) => (
                          <InputSwitch
                            checked={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            disabled={!values.cadastroEnabled || !isAtivo}
                          />
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-12 col-md-6 ps-md-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <Controller
                    name="edicaoEnabled"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        checked={field.value}
                        onChange={(e) => {
                          field.onChange(e.checked);
                          if (!e.checked) {
                            ["endereco", "certidao"].forEach((key) => {
                              formAccordion.setValue(
                                `edicaoCampos.${key}`,
                                false
                              );
                            });
                          }
                        }}
                        disabled={!isAtivo}
                      />
                    )}
                  />
                  <span className="fw-semibold">Edição</span>
                  <i
                    custom-target-icon
                    className="pi pi-question-circle text-secondary custom-target-icon"
                    data-pr-tooltip="Permitir que a IA edite automaticamente esses campos."
                    data-pr-position="right"
                    data-pr-at="right+5 top"
                    data-pr-my="left center-2"
                    style={{ cursor: "pointer" }}
                  />
                </div>
                {[
                  {
                    label: "Comprovante de endereço",
                    key: "endereco",
                  },
                  {
                    label: "Certidão de casamento",
                    key: "certidao",
                  },
                ].map((campo) => (
                  <div
                    key={campo.key}
                    className="d-flex align-items-center justify-content-around mb-2"
                  >
                    <span className="me-2 flex-grow-1">{campo.label}</span>
                    <Controller
                      name={`edicaoCampos.${campo.key}`}
                      control={control}
                      render={({ field }) => (
                        <InputSwitch
                          checked={field.value}
                          onChange={(e) => field.onChange(e.value)}
                          disabled={!values.edicaoEnabled || !isAtivo}
                        />
                      )}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        <div className="d-flex justify-content-end mt-4">
          <Button
            label="Confirmar"
            icon="pi pi-check"
            onClick={handleConfirm}
            disabled={!isAtivo || formState.isSubmitting}
            className="p-button-rounded"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalEditCel;
